import {
  correctEmail,
  correctPhoneNumber,
  hasMinLength,
  hasStringValue,
  maxLengthNotExceeding,
  requiredIfNotExpectedComparerValue
} from "@utilities";

const clientProfile = [
  {
    field: "clientProfile.0.data.clientId",
    validation: hasStringValue
  },
  {
    field: "clientBasicBusiness.0.data.clientBasicBusinessMainGroups",
    validation: hasStringValue
  },
  {
    field: "clientBasicBusiness.0.data.clientBasicBusiness",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.insSect",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.clientId",
    validation: hasMinLength(4)
  },
  {
    field: "clientProfile.0.data.clientId",
    validation: maxLengthNotExceeding(35)
  },
  {
    field: "clientProfile.0.data.clientTitle",
    validation: maxLengthNotExceeding(100)
  },
  {
    field: "clientProfile.0.data.clientLegalStatus",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.clientBirthDate",
    validation: hasStringValue
  },
  {
    field: "clientProfile.0.data.clientRegCountry",
    validation: hasStringValue
  }
];

const clientAdress = [
  {
    field: "clientAddress.0.data.addressCountry",
    validation: hasStringValue
  },
  {
    field: "clientAddress.0.data.addressCity",
    validation: hasStringValue
  },
  {
    field: "clientAddress.0.data.addressStreet",
    validation: hasStringValue
  },
  {
    field: "clientAddress.0.data.addressPostCode",
    validation: hasStringValue
  },
  {
    field: "clientAddress.0.data.addressPostCode",
    validation: maxLengthNotExceeding(8)
  }
];

const secondaryAdress = [
  {
    field: "clientAddress.1.data.addressCountry",
    validation: hasStringValue
  },
  {
    field: "clientAddress.1.data.addressCity",
    validation: hasStringValue
  },
  {
    field: "clientAddress.1.data.addressStreet",
    validation: hasStringValue
  },
  {
    field: "clientAddress.1.data.addressPostCode",
    validation: hasStringValue
  },
  {
    field: "clientAddress.1.data.addressPostCode",
    validation: maxLengthNotExceeding(8)
  },
  {
    field: "clientPhone.0.data.clientPhoneNo",
    validation: hasStringValue
  },
  {
    field: "clientPhone.0.data.clientPhoneNo",
    validation: correctPhoneNumber
  },
  {
    field: "clientPhone.0.data.clientPhoneNo",
    validation: hasMinLength(8)
  },
  {
    field: "clientPhone.0.data.clientPhoneNo",
    validation: maxLengthNotExceeding(20)
  },
  {
    field: "clientPhone.0.data.clientPhoneNo",
    validation: maxLengthNotExceeding(20)
  },
  {
    field: "clientMail.0.data.clientEmail",
    validation: hasStringValue
  },
  {
    field: "clientMail.0.data.clientEmail",
    validation: correctEmail
  },
  {
    field: "clientTaxPayerCountrys.0.data.clientTaxPayerCountry",
    validation: hasStringValue
  },
  {
    field: "clientTaxPayerCountrys.0.data.clientTaxPayerId",
    compareField: "clientTaxPayerCountrys.0.data.clientTaxPayerCountry",
    validation: requiredIfNotExpectedComparerValue("LT")
  }
];

export const STEP_1_VALIDATIONS = [...clientProfile, ...clientAdress, ...secondaryAdress];
